import { render, staticRenderFns } from "./PopupScore.vue?vue&type=template&id=6e01a9c6&scoped=true&"
import script from "./PopupScore.vue?vue&type=script&lang=js&"
export * from "./PopupScore.vue?vue&type=script&lang=js&"
import style0 from "./PopupScore.vue?vue&type=style&index=0&id=6e01a9c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e01a9c6",
  null
  
)

export default component.exports